import FrameQuotes from "./quotes.component";

export default FrameQuotes;
